import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Patrimony } from 'src/app/shared/interfaces/patrimony.interface';
import { PatrimonyService } from '../patrimony.service';

@Component({
  selector: 'app-patrimony-view',
  templateUrl: './patrimony-view.component.html',
  styleUrls: ['./patrimony-view.component.css']
})
export class PatrimonyViewComponent implements OnInit {
  id: number;
  patrimony: Patrimony;

  constructor(
    private patrimonyService: PatrimonyService,
    private activatedRoute: ActivatedRoute
  ){
    this.activatedRoute.params.subscribe((params) => {
      if (params.id) {
        this.id = params.id;
        this.get();
      }
    });
   }

  ngOnInit(): void {
  }

  get():Promise<any>{
    return this.patrimonyService.getById(this.id).then((res)=>{
      const { acquisition_date, 
              annotations, 
              conservation_state, 
              description, 
              situation, 
              type, 
              value,
      } = res;

      const formatedDate = acquisition_date.substr(0,10);
      this.patrimony = {
        acquisition_date: formatedDate,
        annotations,
        conservation_state,
        description,
        situation,
        type,
        value};
    })
  }
}
